// Fonction modifiée pour créer un séparateur de période avec indication d'inclusion
export function createPeriodSeparator(data) {
  const separator = document.createElement('div');
  separator.className = data.isStart ? 'period-separator period-start-separator' : 'period-separator period-end-separator';

  // Première ligne séparatrice
  const lineLeft = document.createElement('div');
  lineLeft.className = 'separator-line';

  // Label du séparateur
  const label = document.createElement('div');
  label.className = 'separator-label';
  label.textContent = data.isStart ? 'Début de la période' : 'Date Anniversaire';

  // Deuxième ligne séparatrice
  const lineRight = document.createElement('div');
  lineRight.className = 'separator-line';

  // Assembler les éléments MARKUP
  separator.appendChild(lineLeft);
  separator.appendChild(label);
  separator.appendChild(lineRight);

  return separator;
}

// Fonction pour créer un séparateur "maintenant"
export function createTodaySeparator() {
  const separator = document.createElement('div');
  separator.className = 'period-separator today-separator';
  separator.id = 'today';

  // Première ligne séparatrice
  const lineLeft = document.createElement('div');
  lineLeft.className = 'separator-line';

  // Label du séparateur
  const label = document.createElement('div');
  label.className = 'separator-label today-label';
  label.textContent = 'Aujourd\'hui';

  // Deuxième ligne séparatrice
  const lineRight = document.createElement('div');
  lineRight.className = 'separator-line';

  // Assembler les éléments MARKUP aujourd'hui
  separator.appendChild(lineLeft);
  separator.appendChild(label);
  separator.appendChild(lineRight);

  return separator;
}